import { createReducer, on, Action } from '@ngrx/store';

import { ChatType } from '../models/chat.models';

import {
    CloseChat,
    CreateChatComponentDeclined,
    CreateChatComponentFailed,
    CreateChatComponentSuccess,
    DestroyChatComponentSuccess,
    EnableHubtype,
    EnableHubtypeSuccess,
    EnableKakao,
    EnableMocha,
    EnableStyleAdvisor,
    EnableUrlChat, HideChatButton,
    IncrementEnabledChats,
    InitHubtypeWidgetSuccess,
    InitializeChatSuccess,
    OpenChat,
    ResetEnabledChats,
    SetActiveChat,
    SetLiveHelp,
    SetScheduleText, ShowChatButton, ShowLargeButtonChat, ShowSmallButtonChat,
    ToggleChat,
} from './chat.actions';
import { chatInitialState, ChatState } from './chat.state';

/**
 * Definicion de las acciones que implementa el "userReducer"
 */
const chatReducerDefinition = createReducer(
    chatInitialState,

    on(InitializeChatSuccess, (state: ChatState, payload): any => {
        return {
            ...state,
            loaded: true,
            visible: payload.visible,
        };
    }),
    on(EnableHubtype, (state: ChatState, { payload }): any => {
        const hubType = { opened: false, loaded: false, configuration: payload };
        return {
            ...state,
            activeChat: ChatType.HUBTYPE,
            scheduleMessage: payload.scheduleMessage || state.scheduleMessage,
            active: payload.active,
            enabled: true,
            hubType,
        };
    }),
    on(EnableHubtypeSuccess, (state: ChatState): any => {
        return {
            ...state,
            hubType: { ...state.hubType, loaded: true },
        };
    }),
    on(ToggleChat, (state: ChatState): any => {
        return { ...state, opened: !state.opened };
    }),
    on(CloseChat, (state: ChatState): any => {
        return { ...state, opened: false };
    }),
    on(OpenChat, (state: ChatState): any => {
        return { ...state, opened: true };
    }),
    on(SetLiveHelp, (state: ChatState): any => {
        return { ...state, activeChat: ChatType.LIVE_HELP_WINDOW, visible: true };
    }),
    on(EnableStyleAdvisor, (state: ChatState, { payload }): any => {
        const styleAdvisor = { loaded: false, configuration: payload };
        return {
            ...state,
            enabled: true,
            activeChat: ChatType.STYLE_ADVISOR,
            styleAdvisor,
        };
    }),
    on(EnableKakao, (state: ChatState, { payload }): any => {
        const kakaoTalk = { loaded: false, configuration: payload };
        return {
            ...state,
            activeChat: ChatType.KAKAOTALK,
            enabled: true,
            scheduleMessage: payload.scheduleMessage || state.scheduleMessage,
            active: payload.active,
            kakaoTalk,
        };
    }),
    on(EnableMocha, (state: ChatState, { scheduleMessage }): ChatState => {
        return {
            ...state,
            activeChat: ChatType.MOCHACHAT,
            active: true,
            enabled: true,
            scheduleMessage: scheduleMessage || state.scheduleMessage,
            mochaChat: { loaded: true },
        };
    }),
    on(EnableUrlChat, (state: ChatState, { payload }): any => {
        const urlChat = { loaded: true, configuration: payload };
        return {
            ...state,
            activeChat: ChatType.URLCHAT,
            scheduleMessage: payload.scheduleMessage || state.scheduleMessage,
            active: payload.active,
            enabled: true,
            urlChat,
        };
    }),
    on(ResetEnabledChats, (state: ChatState) => {
        return {
            ...state,
            enabled: false,
            visible: false,
            enabledChats: 0,
        };
    }),
    on(IncrementEnabledChats, (state: ChatState, { quantity }): ChatState => {
        return {
            ...state,
            enabledChats: state.enabledChats + quantity,
        };
    }),
    on(SetActiveChat, (state: ChatState, { active }): ChatState => {
        return {
            ...state,
            active,
        };
    }),
    on(SetScheduleText, (state: ChatState, { scheduleMessage }): ChatState => {
        return {
            ...state,
            enabled: true,
            scheduleMessage,
        };
    }),
    on(InitHubtypeWidgetSuccess, (state: ChatState): ChatState => {
        return {
            ...state,
            widgetLoaded: true,
        };
    }),
    on(CreateChatComponentSuccess, (state: ChatState): ChatState => {
        return {
            ...state,
            htmlLoaded: true,
        };
    }),
    on(CreateChatComponentFailed, (state: ChatState): ChatState => {
        return {
            ...state,
            htmlLoaded: false,
        };
    }),
    on(CreateChatComponentDeclined, (state: ChatState): ChatState => {
        return {
            ...state,
            htmlLoaded: false,
        };
    }),
    on(ShowLargeButtonChat, (state: ChatState): ChatState => {
        return {
            ...state,
            isLargeButtonChat: true,
        };
    }),
    on(ShowSmallButtonChat, (state: ChatState): ChatState => {
        return {
            ...state,
            isLargeButtonChat: false,
        };
    }),
    on(DestroyChatComponentSuccess, (): ChatState => {
        return {
            ...chatInitialState,
        };
    }),
    on(ShowChatButton, (state: ChatState): any => {
        return {
            ...state,
            isButtonVisible: true,
        };
    }),
    on(HideChatButton, (state: ChatState): any => {
        return {
            ...state,
            isButtonVisible: false,
        };
    }),
);

/**
 * Reducer para el usuario actual
 */
export function chatReducer(state: ChatState, action: Action): ChatState {
    return chatReducerDefinition(state, action);
}
